module.exports = __webpack_public_path__ + "static/media/loading.fef1f20a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.gif
// module id = 1804
// module chunks = 0